<template>
    <div>
        <config-item-value-list
                v-if="!editMode"
                :item="item"
                @new-value="newValue"
                @edit-value="editValue"
        >
        </config-item-value-list>

        <config-value-add-edit
                v-if="editMode"
                :item="item"
                :value="activeValue"
                @view-mode="setViewMode"
                @value-created="valueCreated"
        >
        </config-value-add-edit>
    </div>
</template>

<script>
    import ConfigValueAddEdit from './ConfigValueAddEdit'
    import ConfigItemValueList from './ConfigItemValueList'

    export default {
        name: "config-item-values",

        components: {
            ConfigValueAddEdit,
            ConfigItemValueList
        },

        props: {
            item: {
                required: true,
                type: Object
            }
        },

        data() {
            return {
                editMode: false,
                activeValue: null,
            }
        },

        watch: {
            item: function () {
                this.editMode = false
                this.value = null
            }
        },

        methods: {
            newValue() {
                this.editMode = true
                this.activeValue = null
            },

            editValue({value}) {
                this.editMode = true
                this.activeValue = value
            },

            setViewMode() {
                this.editMode = false
            },

            valueCreated(value) {
                this.activeValue = value

                this.$emit('value-created', value)
            }
        }
    }
</script>

<style scoped>

</style>